export const COMMERCE_PARTNER_NAMES = {
  ZALORA: 'Zalora'
}